import { type VFormFieldChoice } from "@/utils/DjangoTypes";
import { isEqual } from "lodash";

export interface FieldChoicableType {
  id: number | string;
  name: string;
}

export interface SelectableEntity {
  title: string;
  subtitle?: string;
}

export function toVFormFieldChoiceSingle<K extends string | number>(
  item: FieldChoicableType,
  mutateTitle?: (srcItem: FieldChoicableType) => string
): VFormFieldChoice<K> {
  return {
    title: mutateTitle ? mutateTitle(item) : item.name,
    value: item.id as K,
  };
}

export function toVFormFieldChoice<K extends string | number>(
  items: FieldChoicableType[],
  mutateTitle?: (srcItem: FieldChoicableType) => string
): VFormFieldChoice<K>[] {
  return items.map(val => toVFormFieldChoiceSingle(val, mutateTitle));
}

export function getEntityDiff<T extends { [key: string]: any }>(originalItem: T | undefined, updatedItem: T): Partial<T> {
  if (!originalItem) {
    return updatedItem;
  }

  const diff: Partial<T> = {};

  Object.keys(updatedItem as T).forEach(key => {
    const fieldKey = key as keyof T;
    if (!isEqual(updatedItem[fieldKey], originalItem[fieldKey])) {
      diff[fieldKey] = updatedItem[fieldKey];
    }
  });

  return diff;
}

export function scrollToFirstError() {
  const el = document.getElementsByClassName("v-field--error");
  if (el.length > 0 && el[0] instanceof HTMLElement) {
    el[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
};